/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const dividerStyle = (height: undefined | number) => css`
  background-color: #f4f7f8;
  height: ${height ?? 10}px;
  width: 100%;
`;

export interface DividerProps {
  data?: { height?: number };
}

const Divider = ({ data = { height: 8 } }: DividerProps) => {
  const { height } = data;

  return <div css={dividerStyle(height)} />;
};

export default Divider;
